import React from "react";
import {
  DataGrid,
  FilterRow,
  Column,
  Lookup,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarCalendarioIndicesTrimapDs } from "../DataSources.js";
import { criarIndicesTrimapDs } from "../DataSources.js";

export default class CalendarioIndicesTrimapBox extends React.Component {
  constructor() {
    super();

    this.calendarioIndicesTrimapDs = criarCalendarioIndicesTrimapDs();
    this.indicesTrimapDs = criarIndicesTrimapDs();
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="Calendário de Índices Trimap" ocultarNovo={true}>
          <DataGrid
            dataSource={this.calendarioIndicesTrimapDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <FilterRow visible={true} />
            <Column dataField={"indiceId"} caption={"Índice"}>
              <Lookup
                dataSource={this.indicesTrimapDs}
                valueExpr={"indiceId"}
                displayExpr={"indice"}
              />
            </Column>
            <Column dataField={"referencia"} caption={"Referência"} />
            <Column dataField={"data"} editorType={"datetime"} />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }
}
